import { Component, OnInit } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { ContextService, LoginData } from '../../context.service';

@Component({
    selector: 'mutara-delegation-wrapper',
    template: `<div class='status'> <ng-container #fieldComponent></ng-container></div>`,
    standalone: false
})
export class ComponentWrapperComponent extends FieldWrapper implements OnInit {
  adminLogin: LoginData | undefined;

  constructor(private context: ContextService) {
    super(); // Call up to Formly
    console.log('Constructing delegation wrapper')
  }

  ngOnInit() {
    this.context.subscribeTo("loginData",  (login: LoginData) => {
        // Need to have a delegated id to load the form
        if (!!login?.defaultLayout) {
          this.adminLogin = { ...login }; // Copy this so we can update the login
          //        this.context.setLoginData( login );
      }
    });
    // All the rest of this can only work if the login is like  
  }
}